"use client";

import { negotiateLanguage } from "@repo/i18n";
import { useParams } from "next/navigation";

export const useLanguage = () => {
  const { language } = useParams<{ language: string }>();

  return negotiateLanguage(language);
};
